"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Thu Aug 09 2018
 */

var CompetitorPriceIndexConverter_1 = require("./CompetitorPriceIndexConverter");

var CompetitorPriceIndex_1 = require("../model/CompetitorPriceIndex");

var CompetitorPriceIndexConverterImpl =
/*#__PURE__*/
function (_CompetitorPriceIndex) {
  _inherits(CompetitorPriceIndexConverterImpl, _CompetitorPriceIndex);

  function CompetitorPriceIndexConverterImpl() {
    _classCallCheck(this, CompetitorPriceIndexConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(CompetitorPriceIndexConverterImpl).apply(this, arguments));
  }

  _createClass(CompetitorPriceIndexConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new CompetitorPriceIndex_1.CompetitorPriceIndex(source.competitorId, conversions.toBigNumber(source.index));
    }
  }, {
    key: "documentToObject",
    value: function documentToObject(conversions) {
      var _this = this;

      return function (doc) {
        return _this.toObject(doc, conversions);
      };
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        competitorId: source.competitorId,
        index: conversions.fromBigNumber(source.index)
      });
      return result;
    }
  }]);

  return CompetitorPriceIndexConverterImpl;
}(CompetitorPriceIndexConverter_1.CompetitorPriceIndexConverter);

exports.CompetitorPriceIndexConverterImpl = CompetitorPriceIndexConverterImpl;